export interface WebIdentificationStatusResult {
    tooltip: string;
    icon?: string;
    isFilled?: boolean;
    iconType?: 'warning' | 'danger' | 'success' | 'info';
    busnessIdentificationHamburger: ('downloadUEISIGN' | 'downloadUEICREATE' | 'downloadUEIJSON' | 'sendDocOTC' | 'details')[];
    busnessHistoryHamburger: WebIdentificationStatusResult['busnessIdentificationHamburger'];
}

export const getWebIdentificationStatus = (row: any, texts: any): WebIdentificationStatusResult => {
    let icon: WebIdentificationStatusResult['icon'] = '';
    let iconColor: WebIdentificationStatusResult['iconType'] = 'success';
    let tooltip: WebIdentificationStatusResult['tooltip'] = '';
    let busnessIdentificationHamburger: WebIdentificationStatusResult['busnessIdentificationHamburger'] = [];
    let busnessHistoryHamburger: WebIdentificationStatusResult['busnessHistoryHamburger'] = [];
    let isFilled: WebIdentificationStatusResult['isFilled'] = true;

    if (row.status === "EXPIRED") {
        icon = 'hourglass_empty';
        if (row.registrationReviewStatus === 'ALLOWED' && row.result?.signsessionId) {
            iconColor = 'success';
            busnessHistoryHamburger= ['details']
            tooltip = texts.expiredApproveIdent;
        } else {
            iconColor = 'danger';
            tooltip = texts.expiredIdent;
        }
    }
    else if (row.status === 'SIGN_SESSION' && row.step === 'OPERATION_CANCEL_BY_USER') {
        icon = 'info';
        iconColor = 'danger';
        tooltip = texts.chancelByUser;
    }
    else if (row.status === 'SIGN_SESSION' && row.step !== 'SIGNING_WITH_SIGN_SESSION_SUCCESS') {
        icon = 'info';
        iconColor = 'warning';
        tooltip = texts.waitingSignedFromClient;
    }
    else if (row.step === 'SIGNING_WITH_SIGN_SESSION_SUCCESS') {
        icon = 'done';
        iconColor = 'success';
        busnessIdentificationHamburger = [getButtonDownload(row), 'downloadUEIJSON'];
        busnessHistoryHamburger= ['details']
        tooltip = texts.clientSignedDocuments;
    }
    else if (row.step === 'WEB_IDV_REGISTRATION') {
        icon = 'face';
        iconColor = 'warning';
        tooltip = texts.webIdv;
    }
    else if (row.status !== 'SIGN_SESSION' && row.step === 'OPERATION_CANCEL_BY_USER') {
        icon = 'face';
        iconColor = 'danger';
        tooltip = texts.cancelledByUser;
    }
    else if (row.registrationReviewStatus === 'ALLOW_DENY') {
        icon = 'face';
        iconColor = 'success';
        tooltip = texts.clientHasComplited;
    }
    else if (row.step === 'SIGN_SESSION_ID_SUCCESSFULLY_CREATED' && row.registrationReviewStatus === 'ALLOWED') {
        icon = 'check_circle';
        iconColor = 'success';
        isFilled = false;
        tooltip = texts.allowedDocument;
        busnessIdentificationHamburger = [getButtonDownload(row), 'downloadUEIJSON', 'sendDocOTC'];
        busnessHistoryHamburger= ['details']
    }
    else if (row.registrationReviewStatus === 'ALLOWED') {
        icon = 'check_circle';
        iconColor = 'info';
        isFilled = false;
        tooltip = texts.signedUEIAndAllowed;
    }
    else if (row.registrationReviewStatus === 'DENIED') {
        icon = 'check_circle';
        isFilled = false;
        iconColor = 'danger';
        tooltip = texts.identDenied;
    }
    
    return { tooltip, icon, iconType: iconColor, busnessIdentificationHamburger, busnessHistoryHamburger, isFilled }
}

const getButtonDownload = (row: any) => {
    let buttonDownload: "downloadUEISIGN" | "downloadUEICREATE" = 'downloadUEICREATE';
    if (row.status === 'CREATE_SIGN_SESSION_REQUEST' && row.step === 'SIGN_SESSION_ID_SUCCESSFULLY_CREATED') {
        return 'downloadUEICREATE';
    }

    else {
        let isHaveSingSesId = (row.result?.signsessionId ?? '').length !== 0;
        if (isHaveSingSesId) {
            buttonDownload = 'downloadUEISIGN';
        }
    }
    return buttonDownload;
}